import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/AuthContext";
import { useI18n } from "@/i18n";

export default function VerifyEmail() {
  const { verifyEmail } = useAuth();
  const { t } = useI18n();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const [status, setStatus] = useState("loading"); // loading | ok | error

  useEffect(() => {
    const token = params.get("token");
    if (!token) { setStatus("error"); return; }
    verifyEmail(token).then(() => setStatus("ok")).catch(() => setStatus("error"));
  }, []); // eslint-disable-line

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-5 py-16">
      <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md bg-white rounded-2xl border border-[#EBDDD3] p-10 text-center" data-testid="verify-email-page">
        {status === "loading" && (
          <><Loader2 className="w-10 h-10 text-[#C65338] animate-spin mx-auto mb-4" />
            <p className="text-[#5A4B45]">{t("verify.loading")}</p></>
        )}
        {status === "ok" && (
          <><CheckCircle2 className="w-12 h-12 text-[#5C6646] mx-auto mb-4" />
            <h1 className="font-display text-2xl font-black text-[#2D231F] mb-2">{t("verify.okTitle")}</h1>
            <p className="text-[#8C7A70] mb-6">{t("verify.okMsg")}</p>
            <Button data-testid="verify-go-dashboard" onClick={() => nav("/dashboard")} className="rounded-full bg-[#C65338] hover:bg-[#A93F25] text-white">{t("verify.goDashboard")}</Button></>
        )}
        {status === "error" && (
          <><XCircle className="w-12 h-12 text-[#B0413E] mx-auto mb-4" />
            <h1 className="font-display text-2xl font-black text-[#2D231F] mb-2">{t("verify.errTitle")}</h1>
            <p className="text-[#8C7A70] mb-6">{t("verify.errMsg")}</p>
            <Button data-testid="verify-go-login" onClick={() => nav("/login")} className="rounded-full bg-[#C65338] hover:bg-[#A93F25] text-white">{t("nav.login")}</Button></>
        )}
      </motion.div>
    </div>
  );
}
